<template>
  <div id="contenedor-agregar-contrato-sub-tema">
    <v-card>
      <v-card-title class="secondary--text">
        Agregar Sub Tema
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-2"></v-divider>
      <v-card-text>
        <v-form v-model="formularioValido" ref="registrarContratoSubTema">
          <v-row>
            <custom-autocomplete
              v-model="subTema.idTema"
              cols="12"
              label="Tema"
              :items="getContratoTemas"
              itemText="descripcion"
              itemValue="id"
              clearable
              :rules="[mixReglas.requerido]"
            >
            </custom-autocomplete>
            <v-col cols="12">
              <TextArea
                v-model="subTema.descripcion"
                label="Descripción"
                rows="2"
                :rules="[mixReglas.requerido]"
              >
              </TextArea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixAgergarSubTema"
          :disabled="!formularioValido || enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Guardar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CONTRATO_TEMAS from '@/graphql/querys/administracion/contratos/contrato/temas/contratoTemas.gql';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixSubTemasContrato from './mixSubTemasContrato';

export default {
  name: 'AgregarContratoSubTema',
  mixins: [mixSubTemasContrato],
  components: {
    TextArea,
    CustomAutocomplete,
    CustomButton,
  },
  props: {
    idTema: {
      type: String,
      required: true,
    },
    idContrato: {
      type: String,
      required: true,
    },
  },
  apollo: {
    contratoTemas: {
      query: CONTRATO_TEMAS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      formularioValido: false,
      subTema: {
        idTema: this.idTema,
        descripcion: '',
      },
    };
  },
  methods: {
    cerrar() {
      this.$refs.registrarContratoSubTema.reset();
      this.$emit('cerrar');
    },
  },
  computed: {
    getContratoTemas() {
      if (!this.contratoTemas) return [];
      return this.contratoTemas;
    },
  },
  watch: {
    idTema: {
      handler() {
        this.subTema.idTema = this.idTema;
      },
    },
  },
};
</script>

<style lang="scss"></style>
